export enum DialogSeverity {
  // Lowercase for use in classes
  Default = 'default',
  Warning = 'warning',
  Error = 'error',
  Succes = 'success',
}
